<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import StoryblokComponent from "$lib/StoryblokComponent.svelte";
  import type { ColumnsStoryblok } from "$types/components";
  import { displayType } from "$lib/utils/breakpoints";

  export let blok: ColumnsStoryblok;

  $: columns = blok.columns;
  $: {
    if (blok.columns && blok.reverseMobileLayout && $displayType === "mobile") {
      columns = blok.columns?.toReversed();
    }
  }
  $: equalColumns = !blok.columnLayout || blok.columnLayout === 'equal';
</script>

<div
  class="grid {blok?.verticalAlignment}"
  class:gap-2={blok.spacing === "xsmall"}
  class:md:gap-4={blok.spacing === "xsmall"}
  class:gap-4={blok.spacing === "small"}
  class:md:gap-6={blok.spacing === "small"}
  class:gap-6={!blok.spacing || blok.spacing === "medium"}
  class:md:gap-8={!blok.spacing || blok.spacing === "medium"}
  class:gap-8={blok.spacing === "large"}
  class:md:gap-10={blok.spacing === "large"}
  class:gap-10={blok.spacing === "extra-large"}
  class:md:gap-16={blok.spacing === "extra-large"}
  class:gap-16={blok.spacing === "2x-extra-large"}
  class:md:gap-24={blok.spacing === "2x-extra-large"}
  class:gap-y-2={blok.spacing === "xsmall"}
  class:md:gap-y-4={blok.spacing === "xsmall"}
  class:gap-y-4={blok.spacing === "small"}
  class:md:gap-y-6={blok.spacing === "small"}
  class:gap-y-6={blok.spacing === "medium"}
  class:md:gap-y-8={blok.spacing === "medium"}
  class:gap-y-8={blok.spacing === "large"}
  class:md:gap-y-12={blok.spacing === "large"}
  class:gap-y-10={blok.spacing === "extra-large"}
  class:md:gap-y-16={blok.spacing === "extra-large"}
  class:gap-y-12={blok.spacing === "2x-extra-large"}
  class:md:gap-y-24={blok.spacing === "2x-extra-large"}
  class:md:grid-cols-2={equalColumns &&
    (!blok.columnCount || Number(blok.columnCount) === 2)}
  class:md:grid-cols-large-left={blok.columnLayout === "large-left"}
  class:md:grid-cols-large-right={blok.columnLayout === "large-right"}
  class:md:grid-cols-3={Number(blok.columnCount) === 3}
  class:md:grid-cols-4={Number(blok.columnCount) === 4}
  use:storyblokEditable={blok}
  style="margin:{blok.margin};"
>
  {#if columns}
    {#each columns as column}
      <StoryblokComponent blok={column} />
    {/each}
  {/if}
</div>
